import React from "react";

/** Up to two initials from a display name or an email's local part. */
export function getInitials(nameOrEmail?: string | null): string {
  const source = (nameOrEmail ?? "").split("@")[0].trim();
  if (!source) return "?";
  const words = source.split(/[\s._-]+/).filter(Boolean);
  const initials =
    words.length > 1 ? words[0][0] + words[1][0] : source.slice(0, 2);
  return initials.toUpperCase();
}

/**
 * Initials circle for people in a ticket. The dashboard has no Avatar
 * primitive yet; this mirrors the one in the SideNav account control, with
 * the brand tint for the support team and a neutral one for everyone else.
 */
export function InitialsAvatar({
  name,
  tone = "neutral",
}: {
  name?: string | null;
  tone?: "brand" | "neutral";
}) {
  const toneClass =
    tone === "brand"
      ? "bg-semantic-bg-brand-secondary text-semantic-text-brand"
      : "bg-semantic-bg-tertiary text-semantic-text-secondary";
  return (
    <span
      aria-hidden="true"
      className={`flex h-7 w-7 flex-none items-center justify-center rounded-full text-[11px] font-semibold uppercase ${toneClass}`}
    >
      {getInitials(name)}
    </span>
  );
}
